import { createSlice } from "@reduxjs/toolkit";
import { reducerPaths } from "../../app/reducerPaths";
import { liveAuctionApi, useGetBidHistoryQuery } from "./liveAuctionApi";
import { revertAll } from "../../app/revertAll";
import { Bidding_Through } from "../../utils/constants/auction";

const initialState = {
  liveAuctionData: {
    data: [],
  },
  bidHistory: {
    data: []
  }
};

const liveAuctionSlice = createSlice({
  name: reducerPaths.liveAuction,
  initialState,
  reducers: {
    setLiveAuctionMultipleFields: (state, action) => {
      for (let i = 0; i < Object.entries(action?.payload)?.length; i++) {
        state[Object.entries(action?.payload)?.[i]?.[0]] = Object.entries(action?.payload)?.[i]?.[1];
      }
    },
    resetLiveAuctionSlice: (state, action) => {
      return initialState;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(revertAll, () => initialState);
    builder.addMatcher(
      liveAuctionApi.endpoints.getBidHistory.matchFulfilled,
      (state, { payload }) => {
        if (payload) {
          state.bidHistory.data = (payload?.TopBids || [])
            ?.filter?.(bid => {
              return (bid?.Bidding_Through === Bidding_Through.Auction)
            })
            ?.map?.(bid => {
              return {
                ...(bid || {}),
                amount: bid?.Bid_Amount,
                dateTime: bid?.Bid_Date,
                id: bid?.Bid_Id,
                dealerId: bid?.Dealer_Id,
                deliveryMode: bid?.Delivery_Mode,
                Vehicle_Id: bid?.Vehicle_Id,
              }
            })
        }
      }
    );
  }
});

export const {
  setLiveAuctionMultipleFields,
  resetLiveAuctionSlice
} = liveAuctionSlice.actions;

export default liveAuctionSlice.reducer;
